import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import {
  getCatalogSeoSmallDescription,
  getCatalogSeoSmallDescriptionExists,
} from 'store/ProductCatalog/selectors';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export class SeoPreFooterLayout extends React.Component {
  state = { isShown: false };

  toggle = () => {
    const { isShown } = this.state;
    this.setState({ isShown: !isShown });
  };

  toggleText = () => {
    const { isShown } = this.state;
    const { showLabel, hideLabel } = this.props;
    return isShown ? hideLabel : showLabel;
  };

  render() {
    const { isShown } = this.state;
    const { isMobile, className, seoDescription, hasSeoDescription } = this.props;
    return (
      hasSeoDescription && (
        <div
          role="presentation"
          className={cx('wrapper', className, isMobile && 'mobile', isShown ? 'show' : 'hide')}
        >
          <div className={cx('content')} dangerouslySetInnerHTML={{ __html: seoDescription }} />
          {isMobile ?
            <div
              className={cx('toggle', isShown ? 'show' : 'hide')}
              onClick={this.toggle}
              role="button"
              tabIndex={0}
            >
              <span className={cx('dotted', { toggleActive: isShown })}>
                {this.toggleText(isShown)}
              </span>
            </div>
          : null}
        </div>
      )
    );
  }
}

SeoPreFooterLayout.propTypes = {
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  hasSeoDescription: PropTypes.bool,
  seoDescription: PropTypes.string,
  showLabel: PropTypes.string,
  hideLabel: PropTypes.string,
};

SeoPreFooterLayout.defaultProps = {
  showLabel: 'Раскрыть',
  hideLabel: 'Скрыть',
};

const mapStateToProps = (state) => ({
  isMobile: isScreenBelow800(state),
  hasSeoDescription: getCatalogSeoSmallDescriptionExists(state),
  seoDescription: getCatalogSeoSmallDescription(state),
});

// const mapDispatchToProps = {
//   onClick: setSeoShowFullText,
// };

export default connect(mapStateToProps)(SeoPreFooterLayout);
